import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import LoadingOverlay from "../ExpectedTrackForm/LoadingOverlay";
import { getData, postDataWithBody } from "../../../Services/Services";
import { getAllCameraNotifications, getAllCameras, getAllCurrentLiveData, getallforuserdet, getAllRecordingsByFilters, getAnalyticsDataByDate, markAllReadCameraNotifications, startRecordingLive, stopRecordingLive } from "../../../Services/EndPoints";
import {
    Users, UserCheck, UserX, Play, Pause, BellOff,
    RefreshCw, Video, Download, Camera, AlertTriangle, TrendingUp,
    Clock, MapPin, Activity, Grid, Maximize2,
    BarChart3, PieChart, Eye,
    Check, Film
} from "lucide-react";
import "./RealTimeCrowdMonitoring.css";
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import Hls from 'hls.js';

const RealTimeCrowdMonitoring = () => {
    // Camera and streaming states
    const [selectedAnalyticsCamera, setSelectedAnalyticsCamera] = useState('ALL');
    const recordingVideoRef = useRef(null);
    const [recordingId, setRecordingId] = useState(null);
    const [cameras, setCameras] = useState([]);
    const [selectedCamera, setSelectedCamera] = useState(null);
    const [streamUrl, setStreamUrl] = useState("");
    const [analyticsResponse, setAnalyticsResponse] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [hasLoadedAnalytics, setHasLoadedAnalytics] = useState(false);
    const [faceStatsFailed, setFaceStatsFailed] = useState(false);
    const [isLive, setIsLive] = useState(true);
    const [alertsEnabled, setAlertsEnabled] = useState(true);
    const [audioAlertsEnabled, setAudioAlertsEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [cameraError, setCameraError] = useState(null);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingDuration, setRecordingDuration] = useState(0);

    // Add these with your other state declarations at the top
const [recordings, setRecordings] = useState([]);
const [selectedRecording, setSelectedRecording] = useState(null);
const [isLoadingRecordings, setIsLoadingRecordings] = useState(false);
const [recordingFilters, setRecordingFilters] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return {
        fromDate: `${year}-${month}-${day}`,
        toDate: `${year}-${month}-${day}`,
        cameraId: 'ALL'
    };
});

    // Add this helper function to convert to local datetime string for input
const getLocalDateTimeString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

    // Update the initial state for dateRange
const [dateRange, setDateRange] = useState(() => {
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    return {
        from: getLocalDateTimeString(startOfDay),
        to: getLocalDateTimeString(now),
        isCustom: false
    };
});
    
    // View mode states
    const [viewMode, setViewMode] = useState('single'); // 'single', 'grid', 'analytics'
    const [showZones, setShowZones] = useState(false);
    
    // Filter and search states
    const [alertFilter, setAlertFilter] = useState('all'); // 'all', 'known', 'unknown', 'high', 'medium', 'low'
    const [searchQuery, setSearchQuery] = useState('');
    // const [dateRange, setDateRange] = useState('today'); // 'today', 'week', 'month'
    
    // Analytics states
    const [analytics, setAnalytics] = useState({
        avgCrowdSize: 0,
        peakTime: '',
        totalDetections: 0,
        occupancyRate: 0,
        avgDwellTime: 0,
        entryCount: 0,
        exitCount: 0,
        crowdTrend: 'stable' // 'increasing', 'decreasing', 'stable'
    });


    const [faceStats, setFaceStats] = useState({
  total_faces: 0,
  known_faces: 0,
  unknown_faces: 0,
  timestamp: null,
  server_online: false,
  fps: 0
});
    
    // Historical data for charts
    const [historicalData, setHistoricalData] = useState([]);
    
    // Zone monitoring
    const [zones, setZones] = useState([
        { id: 1, name: 'Entry Zone', x: 50, y: 50, width: 200, height: 150, capacity: 10, current: 0 },
        { id: 2, name: 'Main Area', x: 300, y: 100, width: 300, height: 200, capacity: 25, current: 0 },
        { id: 3, name: 'Exit Zone', x: 650, y: 50, width: 200, height: 150, capacity: 10, current: 0 }
    ]);
    
    // Refs
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const audioContextRef = useRef(null);
    
    // Crowd data state
    const [crowdData, setCrowdData] = useState({
        cameraId: 'CAM-Entrance-01',
        snapshotTime: new Date().toISOString(),
        totalPeopleDetected: 0,
        knownPeopleCount: 0,
        unknownPeopleCount: 0,
        lastAlertType: null,
        lastAlertPersonName: null,
        lastAlertTime: null,
        alertSeverity: null,
        alertDescription: null,
        detectedFaces: [],
        crowdDensity: 'low', // 'low', 'medium', 'high', 'critical'
        motionLevel: 0 // 0-100
    });

    const [alerts, setAlerts] = useState([]);
    const [detectionHistory, setDetectionHistory] = useState([]);
    const [wsClient, setWsClient] = useState(null);
const [isWsConnected, setIsWsConnected] = useState(false);
const [wsEndpoint, setWsEndpoint] = useState(null);

    // Live dashboard data (from WebSocket)
const [liveDashboard, setLiveDashboard] = useState({
  timestamp: null,
  todayEntries: 0,
  todayExits: 0,
  insideTotal: 0,
  knownInside: 0,
  unknownInside: 0,
  lastEvent: {
    cameraType: null,
    known_count: 0,
    unknown_count: 0,
    total_count: 0,
    event_time: null
  }
});

// Add this useEffect with your other useEffects
useEffect(() => {
    if (viewMode === 'recordings') {
        fetchRecordings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [viewMode]); // Only trigger when entering recordings view

    // Initialize camera access
    useEffect(() => {
        initializeAudioContext();
        fetchCameras();

        return () => {
            // Cleanup recording if active
        if (isRecording) {
            stopRecording(true);
        }
            if (audioContextRef.current) {
                audioContextRef.current.close();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Initialize audio context for sound alerts
    const initializeAudioContext = () => {
        try {
            audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        } catch (error) {
            console.error('Error initializing audio context:', error);
        }
    };

    // Update this function
const fetchRecordings = async () => {
    setIsLoadingRecordings(true);
    try {
        let cameraCodeToUse = 'ALL';
        
        // If a specific camera is selected, get its cameraCode
        if (recordingFilters.cameraId !== 'ALL') {
            const selectedCam = cameras.find(cam => cam.cameraId === parseInt(recordingFilters.cameraId));
            if (selectedCam && selectedCam.cameraCode) {
                cameraCodeToUse = selectedCam.cameraCode;
            }
        }
        
        console.log('Fetching recordings with:', {
            cameraCode: cameraCodeToUse,
            fromDate: recordingFilters.fromDate,
            toDate: recordingFilters.toDate
        });
            
        const response = await getData(
            getAllRecordingsByFilters
                .replace("CAMERAID", cameraCodeToUse)
                .replace("FROMDATE", recordingFilters.fromDate)
                .replace("TODATE", recordingFilters.toDate)
        );
        
        console.log('Recordings API Response:', response);
        
        if (response && response.data && Array.isArray(response.data)) {
            setRecordings(response.data);
            
            // Auto-select first recording if available
            if (response.data.length > 0) {
                setSelectedRecording(response.data[0]);
            } else {
                setSelectedRecording(null);
            }
            
            toast.success(`Loaded ${response.data.length} recording(s)`, {
                position: 'top-center',
                autoClose: 2000
            });
        } else {
            setRecordings([]);
            setSelectedRecording(null);
            toast.info('No recordings found for selected filters');
        }
    } catch (error) {
        console.error('Error fetching recordings:', error);
        toast.error('Error loading recordings');
        setRecordings([]);
        setSelectedRecording(null);
    } finally {
        setIsLoadingRecordings(false);
    }
};

   const fetchCameras = async () => {
    try {
        const response = await getData(getAllCameras);
        
        console.log('Camera API Response:', response); // Debug log
        
        // Check if response is directly an array OR has status success
        const cameraList = Array.isArray(response) ? response : 
                          (response && response.status === 'success' && response.data) ? response.data : 
                          null;
        
        if (cameraList && cameraList.length > 0) {
            setCameras(cameraList);
            
            // Set first camera as default
            const firstCamera = cameraList[0];
            setSelectedCamera(firstCamera.cameraId);
            setStreamUrl(firstCamera.streamUrl);
            
            toast.success(`Loaded ${cameraList.length} camera(s)`, {
                position: 'top-center',
                autoClose: 2000
            });
        } else {
            toast.error('No cameras found');
            setCameras([]);
        }
    } catch (error) {
        console.error('Error fetching cameras:', error);
        toast.error('Error loading cameras');
        setCameras([]);
    }
};

// Handle camera selection change
// Handle camera selection change
const handleCameraChange = (cameraId) => {
    const camera = cameras.find(cam => cam.cameraId === parseInt(cameraId));
    if (camera) {
        // Clear video source first to prevent flash of old camera
        if (videoRef.current) {
            videoRef.current.src = "";
        }
        
        // Batch state updates together
        setSelectedCamera(camera.cameraId);
        setStreamUrl(camera.streamUrl);
        setFaceStatsFailed(false); // Reset failed state when switching cameras
        
        // Wait for React to process state updates before loading new video
        setTimeout(() => {
            if (videoRef.current && isLive && !faceStatsFailed) {
                videoRef.current.src = camera.streamUrl;
            }
        }, 50);
        
        toast.success(`Switched to ${camera.cameraName}`, {
            position: 'top-center',
            autoClose: 2000
        });
    }
};

// Update your existing recordings useEffect
useEffect(() => {
    if (viewMode === 'recordings' && recordingVideoRef.current && selectedRecording) {
        const videoUrl = selectedRecording.playlistUrl;
        const video = recordingVideoRef.current;
        
        console.log('📹 Loading recording:', videoUrl);

        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: false,
                enableWorker: true,
                lowLatencyMode: false,
                xhrSetup: function(xhr, url) {
                    xhr.withCredentials = false;
                }
            });
            
            hls.loadSource(videoUrl);
            hls.attachMedia(video);
            
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                console.log('✅ Video loaded');
                toast.success('Recording loaded', {
                    position: 'top-center',
                    autoClose: 1500
                });
            });
            
            hls.on(Hls.Events.ERROR, (event, data) => {
                if (data.fatal) {
                    console.error('❌ Video error:', data);
                    toast.error('Error loading recording', {
                        position: 'top-center',
                        autoClose: 3000
                    });
                }
            });

            return () => {
                hls.destroy();
            };
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = videoUrl;
            video.crossOrigin = 'anonymous';
        }
    }
}, [viewMode, selectedRecording]);


   // Update the applyDateTimeFilter function
const applyDateTimeFilter = () => {
    // Match the From/To pickers: dd-mm-yyyy hh:mm AM/PM (no seconds)
    const fmt = (value) => {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, '0');
        const h = d.getHours() % 12 || 12;
        return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(h)}:${pad(d.getMinutes())} ${d.getHours() >= 12 ? 'PM' : 'AM'}`;
    };
    toast.info(`Filter applied: ${fmt(dateRange.from)} to ${fmt(dateRange.to)}`);
    fetchAnalyticsData();
};

    // Play alert sound
    const playAlertSound = (severity) => {
        if (!audioAlertsEnabled || !audioContextRef.current) return;

        const ctx = audioContextRef.current;
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);

        // Different frequencies for different severities
        const frequency = severity === 'HIGH' ? 800 : severity === 'MEDIUM' ? 600 : 400;
        oscillator.frequency.value = frequency;
        oscillator.type = 'sine';

        gainNode.gain.setValueAtTime(0.3, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.5);

        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.5);
    };


    // Start/Stop Recording
    const toggleRecording = () => {
        if (isRecording) {
            stopRecording();
        } else {
            startRecording();
        }
    };



    const getWebSocketEndpoint = () => {
  try {
    const contextPath = process.env.REACT_APP_CORE_CONTEXT_PATH_NAME;
    if (!contextPath) {
      console.error('REACT_APP_CORE_CONTEXT_PATH_NAME is not defined');
      throw new Error('Missing context path environment variable');
    }

    const hostname = window.location.hostname;
    const protocol = window.location.protocol;

    let sockjsUrl;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      sockjsUrl = `http://localhost:7080/${contextPath}/ws`;
    } else {
      sockjsUrl = `${protocol}//${hostname}/${contextPath}/ws`;
    }

    return sockjsUrl;
  } catch (error) {
    console.error("Error constructing WebSocket endpoint:", error);
    const contextPath = process.env.REACT_APP_CORE_CONTEXT_PATH_NAME || 'iccc-service';
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `http://localhost:7080/${contextPath}/ws`;
    } else {
      return `${window.location.protocol}//${hostname}/${contextPath}/ws`;
    }
  }
};


    // New API fetch function for face stats
// Simplified fetchFaceStats - no early returns except for !isLive
// const fetchFaceStats = async () => {
//     if (!isLive) return;
    
//     try {
//         const response = await fetch("http://192.168.0.44:5000/face_stats");
//         if (!response.ok) throw new Error('API request failed');
//         const data = await response.json();

//         // Clear failed state on success
//         setFaceStatsFailed(false);
//         setFaceStats(data);
        
//         if (data.total_faces > 0) {
//             setLiveViewData({
//                 totalPeopleDetected: data.total_faces,
//                 knownPeopleCount: data.known_faces,
//                 unknownPeopleCount: data.unknown_faces,
//                 snapshotTime: data.timestamp
//             });
//         }
//     } catch (error) {
//         setFaceStatsFailed(true);
//         setFaceStats({ 
//             total_faces: 0, 
//             known_faces: 0, 
//             unknown_faces: 0, 
//             timestamp: null, 
//             server_online: false, 
//             fps: 0 
//         });
//     }
// };




const startRecording = async () => {
    if (!selectedCamera || isRecording) return;
    
    try {
        setIsRecording(true);
        setRecordingDuration(0);
        
        // Start the duration timer
        const durationInterval = setInterval(() => {
            setRecordingDuration(prev => prev + 1);
        }, 1000);
        
        // Store the interval ID for cleanup
        mediaRecorderRef.current = { durationInterval };
        
        const response = await getData(
            startRecordingLive.replace("ID", selectedCamera)
        );
        
        if (response && response.status === 'success') {
            setRecordingId(response.recordingId);
            toast.success(response.message || 'Recording started successfully', {
                position: 'top-center',
                autoClose: 2000
            });
        } else {
            throw new Error('Failed to start recording');
        }
    } catch (error) {
        console.error('Start recording error:', error);
        toast.error('Failed to start recording', {
            position: 'top-center',
            autoClose: 3000
        });
        stopRecording(true); // Cleanup on error
    }
};

const stopRecording = async (silent = false) => {
    if (!isRecording || !recordingId) return;
    
    try {
        // Clear duration interval
        if (mediaRecorderRef.current?.durationInterval) {
            clearInterval(mediaRecorderRef.current.durationInterval);
            mediaRecorderRef.current.durationInterval = null;
        }
        
        const response = await getData(
            stopRecordingLive
                .replace("ID", selectedCamera)
                .replace("RECORDING_ID", recordingId)
        );
        
        if (response && response.status === 'success') {
            if (!silent) {
                toast.success(response.message || 'Recording stopped successfully', {
                    position: 'top-center',
                    autoClose: 2000
                });
            }
        } else {
            throw new Error('Failed to stop recording');
        }
    } catch (error) {
        console.error('Stop recording error:', error);
        if (!silent) {
            toast.error('Failed to stop recording', {
                position: 'top-center',
                autoClose: 3000
            });
        }
    } finally {
        setIsRecording(false);
        setRecordingDuration(0);
        setRecordingId(null);
    }
};


  const captureSnapshot = async () => {
  if (!videoRef.current || !isLive || faceStatsFailed) {
    toast.error("No live video available");
    return;
  }

  const img = videoRef.current;
  
  // Wait for video frame to be ready
  if (!img.complete || img.naturalWidth === 0 || img.naturalHeight === 0) {
    toast.error("Video not ready - please wait");
    return;
  }

  try {
    // CREATE SEPARATE SNAPSHOT CANVAS - don't touch overlay canvas
    const snapshotCanvas = document.createElement('canvas');
    snapshotCanvas.width = Math.min(1920, img.naturalWidth);
    snapshotCanvas.height = Math.min(1080, img.naturalHeight);
    const ctx = snapshotCanvas.getContext('2d');

    // Single frame capture - NO LOOPS
    ctx.drawImage(img, 0, 0, snapshotCanvas.width, snapshotCanvas.height);
    
    // Convert to PNG blob (smaller, widely supported)
    snapshotCanvas.toBlob((blob) => {
      if (!blob || blob.size === 0) {
        toast.error("Failed to create image");
        return;
      }

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `snapshot_${selectedCamera}_${new Date().toISOString().replace(/[:.]/g, '-')}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setTimeout(() => URL.revokeObjectURL(url), 100);
      snapshotCanvas.remove(); // Cleanup
      
      toast.success(`Snapshot saved ${(blob.size / 1024).toFixed(0)} KB`);
    }, 'image/png', 0.95); // 95% quality

  } catch (error) {
    console.error('Snapshot error:', error);
    toast.error(`Snapshot failed: ${error.message}`);
  }
};

// Add useEffect to load today's data on component mount
useEffect(() => {
    if (viewMode === 'analytics' && !hasLoadedAnalytics) {
        const now = new Date();
        const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        
        setDateRange({
            from: getLocalDateTimeString(startOfDay),
            to: getLocalDateTimeString(now),
            isCustom: false
        });
        
        setSelectedAnalyticsCamera('ALL');
        setHasLoadedAnalytics(true);
        
        setTimeout(() => {
            fetchAnalyticsData();
        }, 200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [viewMode,hasLoadedAnalytics]);

useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); // Fetch on component mount

// Add this new function to fetch initial dashboard data
const fetchInitialDashboardData = async () => {
    try {
        // Replace with your actual API endpoint
        const response = await getData(getAllCurrentLiveData); // Update this endpoint path
        
        if (response) {
            setLiveDashboard({
                timestamp: response.timestamp || new Date().toISOString(),
                todayEntries: response.todayEntries || 0,
                todayExits: response.todayExits || 0,
                insideTotal: response.insideTotal || 0,
                knownInside: response.knownInside || 0,
                unknownInside: response.unknownInside || 0,
                lastEvent: {
                    cameraType: response.lastEvent?.cameraType || null,
                    known_count: response.lastEvent?.known_count || 0,
                    unknown_count: response.lastEvent?.unknown_count || 0,
                    total_count: response.lastEvent?.total_count || 0,
                    event_time: response.lastEvent?.event_time || null
                }
            });
            console.log('✅ Initial dashboard data loaded:', response);
        }
    } catch (error) {
        console.error('❌ Error fetching initial dashboard data:', error);
    }
};

// Update the WebSocket useEffect
useEffect(() => {
    const httpUrl = getWebSocketEndpoint();
    setWsEndpoint(httpUrl);

    // Fetch initial data immediately when component mounts
    fetchInitialDashboardData();

    const stompClient = new Client({
        webSocketFactory: () => new SockJS(httpUrl),
        reconnectDelay: 5000,
        heartbeatIncoming: 4000,
        heartbeatOutgoing: 4000,
        onConnect: () => {
            setIsWsConnected(true);
            console.log('✅ WebSocket connected');
            
            // Fetch data again when WebSocket connects to ensure latest state
            fetchInitialDashboardData();

            stompClient.subscribe(
                `/topic/live-dashboard`,
                message => {
                    const data = JSON.parse(message.body);
                    console.log('📊 WebSocket update received:', data); 
                    setLiveDashboard(prev => ({
                        ...prev,
                        ...data,
                        lastEvent: {
                            ...prev.lastEvent,
                            ...(data.lastEvent || {})
                        }
                    }));
                }
            );
        },
        onDisconnect: () => {
            setIsWsConnected(false);
            console.log('🔌 WebSocket disconnected');
        },
        onWebSocketError: (error) => {
            setIsWsConnected(false);
            console.error('❌ WebSocket error:', error);
        },
        onStompError: (error) => {
            setIsWsConnected(false);
            console.error('❌ STOMP error:', error);
        }
    });

    stompClient.activate();
    setWsClient(stompClient);

    return () => {
        if (stompClient) {
            stompClient.deactivate();
        }
    };
}, []);

    // Add this new useEffect to handle video visibility based on API status
useEffect(() => {
    if (videoRef.current && streamUrl) {
        if (faceStatsFailed) {
            // API failed - hide video
            videoRef.current.style.display = 'none';
        } else if (isLive) {
            // API recovered and live - show video
            videoRef.current.src = streamUrl;
            videoRef.current.style.display = 'block';
        }
    }
}, [faceStatsFailed, isLive, streamUrl]);

// Update the existing video effect to be simpler
useEffect(() => {
    if (videoRef.current && streamUrl) {
        if (isLive && !faceStatsFailed) {
            videoRef.current.src = streamUrl;
            videoRef.current.style.display = 'block';
        } else {
            videoRef.current.src = "";
            videoRef.current.style.display = 'none';
        }
    }
}, [isLive, faceStatsFailed, streamUrl]); // Add faceStatsFailed as dependency

    // // Handle play/pause
    // useEffect(() => {
    //     if (videoRef.current) {
    //         if (isLive) {
    //             videoRef.current.play().catch(err => console.error('Error playing video:', err));
    //         } else {
    //             videoRef.current.pause();
    //         }
    //     }
    // }, [isLive]);

    // Fetch data on component mount and when camera changes
useEffect(() => {
//   fetchFaceStats();
//   fetchAnalytics();
}, [selectedCamera]);

// Poll face stats only when live video is active
// Simplified polling effect
useEffect(() => {
  if (!isLive) {
    setFaceStats({
      total_faces: 0,
      known_faces: 0,
      unknown_faces: 0,
      timestamp: null,
      server_online: false,
      fps: 0
    });
    setFaceStatsFailed(false); // Reset failure state when paused
    return;
  }

  // Initial fetch
//   fetchFaceStats();

//   // Keep polling - removed all checks
//   const interval = setInterval(fetchFaceStats, 1000);

//   return () => clearInterval(interval);
}, [isLive, selectedCamera]);


    // // Fetch data on component mount and when camera changes
    // useEffect(() => {
    //     fetchCrowdData();
    //     fetchAnalytics();
        
    //     // Set up polling for real-time updates
    //     const interval = setInterval(() => {
    //         if (isLive) {
    //             fetchCrowdData();
    //         }
    //     }, 5000); // Update every 5 seconds

    //     return () => clearInterval(interval);
    // }, [selectedCamera, isLive]);

    // Draw zones only on canvas (face boxes removed)
    useEffect(() => {
        if (showZones && canvasRef.current && videoRef.current) {
            const canvas = canvasRef.current;
            const video = videoRef.current;
            const ctx = canvas.getContext('2d');

            const drawOverlay = () => {
                if (!isLive) return;

                canvas.width = video.videoWidth || 640;
                canvas.height = video.videoHeight || 480;
                
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // Draw zones if enabled
                zones.forEach(zone => {
                    const occupancyPercent = (zone.current / zone.capacity) * 100;
                    let color = '#4CAF50';
                    if (occupancyPercent > 80) color = '#F44336';
                    else if (occupancyPercent > 60) color = '#FF9800';

                    ctx.strokeStyle = color;
                    ctx.lineWidth = 2;
                    ctx.setLineDash([5, 5]);
                    ctx.strokeRect(zone.x, zone.y, zone.width, zone.height);
                    ctx.setLineDash([]);
                    
                    ctx.fillStyle = color;
                    ctx.globalAlpha = 0.2;
                    ctx.fillRect(zone.x, zone.y, zone.width, zone.height);
                    ctx.globalAlpha = 1;
                    
                    ctx.fillStyle = color;
                    ctx.font = 'bold 12px Arial';
                    ctx.fillText(
                        `${zone.name}: ${zone.current}/${zone.capacity}`,
                        zone.x + 5,
                        zone.y + 15
                    );
                });

                requestAnimationFrame(drawOverlay);
            };

            drawOverlay();
        } else if (!showZones && canvasRef.current) {
            // Clear canvas when zones are disabled
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }, [showZones, isLive, zones]);

    // Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentDetections = analyticsResponse?.detectionHistory?.slice(indexOfFirstItem, indexOfLastItem) || [];
const totalPages = Math.ceil((analyticsResponse?.detectionHistory?.length || 0) / itemsPerPage);

const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
};

    const fetchCrowdData = async () => {
        try {
            const response = await getData(getallforuserdet);

            if (response && response.status === 'success') {
                const data = response.data || [];
                
                // Process the data to calculate crowd statistics
                const total = data.length;
                const known = data.filter(item => item.status?.toLowerCase() === 'recognized').length;
                const unknown = total - known;

                // Calculate crowd density
                let density = 'low';
                if (total > 50) density = 'critical';
                else if (total > 30) density = 'high';
                else if (total > 15) density = 'medium';

                // Simulate motion level (in real app, this would come from video analysis)
                const motionLevel = Math.min(100, total * 3.5);

                // Get latest alert
                const latestEntry = data[0];
                
                const newCrowdData = {
                    cameraId: selectedCamera,
                    snapshotTime: new Date().toISOString(),
                    totalPeopleDetected: total,
                    knownPeopleCount: known,
                    unknownPeopleCount: unknown,
                    lastAlertType: latestEntry?.status === 'Recognized' ? 'KNOWN_PERSON_DETECTED' : 'UNKNOWN_PERSON_DETECTED',
                    lastAlertPersonName: latestEntry?.personName || null,
                    lastAlertTime: latestEntry?.logTime || new Date().toISOString(),
                    alertSeverity: unknown > known ? (unknown > 10 ? 'HIGH' : 'MEDIUM') : 'LOW',
                    alertDescription: latestEntry?.status === 'Recognized' 
                        ? `Employee: ${latestEntry?.personName}` 
                        : 'Unknown person detected',
                    detectedFaces: data.slice(0, 10).map((item, index) => ({
                        x: 50 + (index % 3) * 200,
                        y: 50 + Math.floor(index / 3) * 150,
                        width: 80,
                        height: 100,
                        isKnown: item.status?.toLowerCase() === 'recognized',
                        personName: item.personName,
                        confidence: item.confidence || (0.7 + Math.random() * 0.3)
                    })),
                    crowdDensity: density,
                    motionLevel: motionLevel
                };

                setCrowdData(newCrowdData);

                // Update historical data
                setHistoricalData(prev => {
                    const newData = [...prev, {
                        time: new Date().toISOString(),
                        total: total,
                        known: known,
                        unknown: unknown
                    }];
                    return newData.slice(-60); // Keep last 60 data points
                });

                // Update alerts list
                if (latestEntry) {
                    const newAlert = {
                        id: Date.now(),
                        type: latestEntry.status === 'Recognized' ? 'KNOWN_PERSON_DETECTED' : 'UNKNOWN_PERSON_DETECTED',
                        personName: latestEntry.personName,
                        time: latestEntry.logTime || new Date().toISOString(),
                        severity: newCrowdData.alertSeverity,
                        description: latestEntry.status === 'Recognized' 
                            ? `Employee: ${latestEntry.personName}` 
                            : 'Unknown person detected',
                        camera: selectedCamera
                    };
                    
                    setAlerts(prev => {
                        const filtered = prev.filter(a => 
                            !(a.type === newAlert.type && 
                              a.personName === newAlert.personName &&
                              Math.abs(new Date(a.time) - new Date(newAlert.time)) < 10000)
                        );
                        const updated = [newAlert, ...filtered].slice(0, 50);
                        
                        // Play sound for new high severity alerts
                        if (alertsEnabled && newAlert.severity === 'HIGH' && 
                            !prev.some(a => a.id === newAlert.id)) {
                            playAlertSound(newAlert.severity);
                        }
                        
                        return updated;
                    });

                    // Add to detection history
                    setDetectionHistory(prev => {
                        const newHistory = [{
                            id: Date.now(),
                            personName: latestEntry.personName,
                            status: latestEntry.status,
                            time: latestEntry.logTime || new Date().toISOString(),
                            camera: selectedCamera,
                            confidence: latestEntry.confidence || (0.7 + Math.random() * 0.3)
                        }, ...prev];
                        return newHistory.slice(0, 100);
                    });
                }

                // Update zone occupancy (simulated)
                setZones(prev => prev.map(zone => ({
                    ...zone,
                    current: Math.floor(Math.random() * (zone.capacity + 2))
                })));
            }
        } catch (error) {
            console.error('Error fetching crowd data:', error);
        }
    };

    // Add this helper function with your other format functions
const formatTime12Hour = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp.replace(' ', 'T')); // Convert "2025-12-22 18:35:01" to ISO format
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const formattedHours = hours.toString().padStart(2, '0');
    
    return `${day}-${month}-${year} ${formattedHours}:${minutes}:${seconds} ${ampm}`;
};

    // Add this helper function to format dates
const formatDateTimeForAPI = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

   // Update the fetchAnalyticsData function to handle the response structure correctly
const fetchAnalyticsData = async () => {
    setIsLoading(true);
    try {
        const selectedCam = cameras.find(cam => cam.cameraId === parseInt(selectedAnalyticsCamera));
        const payload = {
            startDate: formatDateTimeForAPI(dateRange.from),
            endDate: formatDateTimeForAPI(dateRange.to),
            cameraType: selectedAnalyticsCamera === 'ALL' ? 'ALL' : selectedCam?.cameraType || 'ALL'
        };

        console.log('Fetching analytics with payload:', payload);

        const response = await postDataWithBody(getAnalyticsDataByDate, payload, {});
        
        console.log('Analytics API Response:', response);
        
        // Access the data property from the response
        if (response && response.status === 'success' && response.data) {
            setAnalyticsResponse(response.data);
            setCurrentPage(1);
            
            toast.success('Analytics data loaded', {
                position: 'top-center',
                autoClose: 2000
            });
        } else {
            toast.error('No analytics data received');
        }
    } catch (error) {
        console.error('Error fetching analytics:', error);
        toast.error('Error loading analytics data');
    } finally {
        setIsLoading(false);
    }
};

// Add this helper function to format peak hour
const formatPeakHour = (hourString) => {
    if (!hourString) return 'N/A';
    
    // Extract start and end times from format: "2025-12-19T09:00 to 2025-12-19T09:59:59"
    const parts = hourString.split(' to ');
    if (parts.length !== 2) return hourString;
    
    const startTime = new Date(parts[0].replace('T', ' '));
    const endTime = new Date(parts[1].replace('T', ' '));
    
    // Round end time to next hour
    const roundedEndTime = new Date(endTime);
    roundedEndTime.setMinutes(0);
    roundedEndTime.setSeconds(0);
    roundedEndTime.setHours(roundedEndTime.getHours() + 1);
    
    // Format with AM/PM
    const formatTimeWithAMPM = (date) => {
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesStr = minutes.toString().padStart(2, '0');
        return `${hours.toString().padStart(2, '0')}:${minutesStr} ${ampm}`;
    };
    
    return `${formatTimeWithAMPM(startTime)} - ${formatTimeWithAMPM(roundedEndTime)}`;
};

// Add this function with your other functions (after fetchNotifications)
const markAllNotificationsAsRead = async () => {
    try {
        // Get all unread notification IDs
        const unreadIds = alerts
            .filter(alert => !alert.isRead)
            .map(alert => alert.id);
        
        if (unreadIds.length === 0) {
            toast.info('No unread notifications to mark', {
                position: 'top-center',
                autoClose: 2000
            });
            return;
        }

        const payload = {
            notificationIds: unreadIds
        };

        const response = await postDataWithBody(markAllReadCameraNotifications, payload, {});
        
        if (response && response.status === 'success') {
            toast.success(`Marked ${unreadIds.length} notification(s) as read`, {
                position: 'top-center',
                autoClose: 2000
            });
            
            // Refresh notifications to get updated data
            fetchNotifications();
        } else {
            toast.error('Failed to mark notifications as read');
        }
    } catch (error) {
        console.error('Error marking notifications as read:', error);
        toast.error('Error marking notifications as read');
    }
};

// Add this function after markAllNotificationsAsRead
const markNotificationAsRead = async (notificationId, isRead) => {
    // Don't call API if already read
    if (isRead) return;
    
    try {
        const payload = {
            notificationIds: [notificationId]
        };

        const response = await postDataWithBody(markAllReadCameraNotifications, payload, {});
        
        if (response && response.status === 'success') {
            toast.success('Notification marked as read', {
                position: 'top-center',
                autoClose: 1500
            });
            
            // Refresh notifications to get updated data
            fetchNotifications();
        } else {
            toast.error('Failed to mark notification as read');
        }
    } catch (error) {
        console.error('Error marking notification as read:', error);
        toast.error('Error marking notification as read');
    }
};

// Add this new function after fetchAnalytics
const fetchNotifications = async () => {
    try {
        const response = await getData(getAllCameraNotifications);
        
        console.log('Notifications API Response:', response);
        
        if (response && Array.isArray(response)) {
            // Map API response to alerts format
            const mappedAlerts = response.map(notification => ({
                id: notification.id,
                type: notification.notificationType,
                time: notification.eventTime || notification.createdOn,
                severity: determineSeverity(notification),
                description: notification.notificationMessage,
                camera: notification.cameraType || notification.cameraCode,
                // New fields from API
                seqCode: notification.seqCode,
                notificationTitle: notification.notificationTitle,
                notificationMessage: notification.notificationMessage,
                notificationType: notification.notificationType,
                unKnownCount: notification.unKnownCount,
                isRead: notification.isRead
            }));
            
            setAlerts(mappedAlerts);
            
            // toast.success(`Loaded ${mappedAlerts.length} notification(s)`, {
            //     position: 'top-center',
            //     autoClose: 2000
            // });
        } else {
            // toast.info('No notifications found');
            setAlerts([]);
        }
    } catch (error) {
        console.error('Error fetching notifications:', error);
        toast.error('Error loading notifications');
        setAlerts([]);
    }
};

// Helper function to determine severity based on notification data
const determineSeverity = (notification) => {
    if (notification.notificationType === 'UNKNOWN_PERSON_ALERT') {
        if (notification.unKnownCount > 5) return 'HIGH';
        if (notification.unKnownCount > 2) return 'MEDIUM';
        return 'LOW';
    }
    return 'MEDIUM';
};

    const formatTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};




    const formatDuration = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const getSeverityColor = (severity) => {
        switch (severity) {
            case 'HIGH': return '#F44336';
            case 'MEDIUM': return '#FF9800';
            case 'LOW': return '#4CAF50';
            default: return '#9E9E9E';
        }
    };


    const formatAlertType = (type) => {
        return type?.replace(/_/g, ' ') || '';
    };

    const refreshData = () => {
        fetchNotifications();
        // fetchFaceStats();
        toast.success('Data refreshed', {
            position: 'top-center',
            autoClose: 2000
        });
    };

    // Filter alerts
    const filteredAlerts = alerts.filter(alert => {
        // Filter by type
        if (alertFilter === 'known' && alert.type !== 'KNOWN_PERSON_DETECTED') return false;
        if (alertFilter === 'unknown' && alert.type !== 'UNKNOWN_PERSON_DETECTED') return false;
        if (alertFilter === 'high' && alert.severity !== 'HIGH') return false;
        if (alertFilter === 'medium' && alert.severity !== 'MEDIUM') return false;
        if (alertFilter === 'low' && alert.severity !== 'LOW') return false;

        // Filter by search query
        if (searchQuery && alert.personName) {
            return alert.personName.toLowerCase().includes(searchQuery.toLowerCase());
        }

        return true;
    });

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh'
            }}>
                <LoadingOverlay message="Loading crowd monitoring data..." />
            </div>
        );
    }
console.log(detectionHistory,"DD")
    return (
        <div className="crowd-monitoring-container">
            {/* Header Section */}
            <div className="crowd-monitoring-header">
                <div className="header-left">
                    <h2>Live Crowd Monitoring</h2>
                    <span className="header-subtitle">Advanced Analytics & Surveillance</span>
                </div>
                <div className="header-right">
                    <div className="view-mode-selector">
                        <button 
                            className={viewMode === 'single' ? 'active' : ''}
                            onClick={() => setViewMode('single')}
                            title="Single Camera View"
                        >
                            <Video size={18} />
                        </button>
                        <button 
                            className={viewMode === 'grid' ? 'active' : ''}
                            onClick={() => setViewMode('grid')}
                            title="Grid View"
                        >
                            <Grid size={18} />
                        </button>
                        <button 
                            className={viewMode === 'analytics' ? 'active' : ''}
                            onClick={() => setViewMode('analytics')}
                            title="Analytics Dashboard"
                        >
                            <BarChart3 size={18} />
                        </button>
                         {/* NEW RECORDINGS VIEW BUTTON */}
    <button
        className={viewMode === 'recordings' ? 'active' : ''}
        onClick={() => setViewMode('recordings')}
        title="Recordings"
    >
        <Film size={18} />
    </button>
                    </div>
                    {( viewMode !== 'analytics' && viewMode !== 'recordings' && <div className="camera-selector">
    <label>Camera:</label>
    <select 
        value={selectedCamera || ''} 
        onChange={(e) => handleCameraChange(e.target.value)}
        disabled={cameras.length === 0}
    >
        {cameras.length === 0 ? (
            <option value="">No cameras available</option>
        ) : (
            cameras.map((camera) => (
                <option key={camera.cameraId} value={camera.cameraId}>
                    {camera.cameraName}
                </option>
            ))
        )}
    </select>
</div>
  )}
                    {/* <div className="snapshot-time">
                        <Clock size={16} />
                        <span>{formatDateTime(crowdData.snapshotTime)}</span>
                    </div> */}
                  
                </div>
            </div>
         {(viewMode === 'analytics' && (
    <div className="date-time-filter-section">
        <div className="datetime-pickers">
            <div className="datetime-group">
                <label>From:</label>
                <input
                    type="datetime-local"
                    value={dateRange.from}
                    onChange={(e) => setDateRange(prev => ({ ...prev, from: e.target.value }))}
                    className="datetime-input"
                />
            </div>
            <div className="datetime-group">
                <label>To:</label>
                <input
                    type="datetime-local"
                    value={dateRange.to}
                    onChange={(e) => setDateRange(prev => ({ ...prev, to: e.target.value }))}
                    className="datetime-input"
                />
            </div>
            <div className="datetime-group">
                <label>Camera:</label>
                <select 
    value={selectedAnalyticsCamera}
    onChange={(e) => setSelectedAnalyticsCamera(e.target.value)}
    className="datetime-input"
    style={{ padding: '8px 12px' }}
    disabled={cameras.length === 0}
>
    <option value="ALL">All Cameras</option>
    {cameras.map((camera) => (
        <option key={camera.cameraId} value={camera.cameraId}>
            {camera.cameraName}
        </option>
    ))}
</select>
            </div>
            <button 
                onClick={applyDateTimeFilter}
                className="apply-filter-btn"
                disabled={isLoading}
            >
                {isLoading ? 'Loading...' : 'Apply'}
            </button>
            {/* <button 
                onClick={() => {
                    const now = new Date();
                    const startOfDay = new Date(now.setHours(0, 0, 0, 0)).toISOString().slice(0, 16);
                    const currentTime = new Date().toISOString().slice(0, 16);
                    
                    setDateRange({
                        from: startOfDay,
                        to: currentTime,
                        isCustom: false
                    });
                    setAnalyticsCameraType('ALL');
                    toast.success("Reset to today");
                    setTimeout(() => fetchAnalyticsData(), 100);
                }}
                className="reset-filter-btn"
            >
                Reset
            </button> */}
        </div>
    </div>
))}

            {/* Summary Cards */}
            <div className="crowd-summary-cards" style={
  viewMode === 'single'
    ? {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginBottom: "24px",
      }
    : undefined
}
>
                {viewMode === 'single' ? (
  // Real face stats for single camera view
  <>
  {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "16px" }}>
    <div className="summary-card summary-card-blue" style={{
    padding: "12px 16px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    minHeight: "90px",
  }}>
      <div className="card-icon" style={{ color: '#2196F3' }}>
        <Users size={32} />
      </div>
      <div className="card-content">
        <h3 className="card-title">Total Recognized</h3>
        <p className="card-value">{liveDashboard.lastEvent?.total_count ?? 0}</p>
      </div>
    </div>
    <div className="summary-card summary-card-green" style={{
    padding: "12px 16px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    minHeight: "90px",
  }}>
      <div className="card-icon" style={{ color: '#4CAF50' }}>
        <UserCheck size={32} />
      </div>
      <div className="card-content">
        <h3 className="card-title">Recognized Individuals</h3>
        <p className="card-value">{liveDashboard.lastEvent?.known_count ?? 0}</p> */}
        {/* <span className="card-subtitle">
          {faceStats.total_faces ? ((faceStats.known_faces / Math.max(1, faceStats.total_faces)) * 100).toFixed(0) + '% of total' : 'No data'}
        </span> */}
      {/* </div>
    </div>
    <div className="summary-card summary-card-red" style={{
    padding: "12px 16px",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    minHeight: "90px",
  }}>
      <div className="card-icon" style={{ color: '#F44336' }}>
        <UserX size={32} />
      </div>
      <div className="card-content">
        <h3 className="card-title">Unrecognized Individuals</h3>
        <p className="card-value">{liveDashboard.lastEvent?.unknown_count ?? 0}</p> */}
        {/* <span className="card-subtitle">
          {liveDashboard.lastEvent?.unknown_count > 0 ? 'Alert' : 'Normal'}
        </span> */}
      {/* </div>
    </div> */}
    {/* </div> */}
    {/* Live Count Section */}
    <div className="lcm-stat-section">
      <h3 className="lcm-stat-section-title">
        <Activity size={18} />
        Live Count
      </h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "16px" }}>
        <div className="summary-card summary-card-green" style={{
          padding: "12px 16px",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          minHeight: "90px",
        }}>
          <div className="card-icon" style={{ color: '#4CAF50' }}>
            <TrendingUp size={32} />
          </div>
          <div className="card-content">
            <h3 className="card-title">In</h3>
            <p className="card-value">{liveDashboard.todayEntries || 0}</p>
          </div>
        </div>
        
        <div className="summary-card summary-card-blue" style={{
          padding: "12px 16px",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          minHeight: "90px",
        }}>
          <div className="card-icon" style={{ color: '#2196F3' }}>
            <TrendingUp size={32} style={{ transform: 'rotate(180deg)' }} />
          </div>
          <div className="card-content">
            <h3 className="card-title">Out</h3>
            <p className="card-value">{liveDashboard.todayExits || 0}</p>
          </div>
        </div>
        
        <div className="summary-card summary-card-purple" style={{
          padding: "12px 16px",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          minHeight: "90px",
        }}>
          <div className="card-icon" style={{ color: '#9C27B0' }}>
            <Users size={32} />
          </div>
          <div className="card-content">
            <h3 className="card-title">Total count</h3>
            <p className="card-value">{liveDashboard.insideTotal || 0}</p>
          </div>
        </div>
        
        <div className="summary-card summary-card-orange" style={{
          padding: "12px 16px",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          minHeight: "90px",
        }}>
          <div className="card-icon" style={{ color: '#FF9800' }}>
            <UserCheck size={32} />
          </div>
          <div className="card-content">
            <h3 className="card-title">Identified</h3>
            <p className="card-value">{liveDashboard.knownInside || 0}</p>
          </div>
        </div>
        
        <div className="summary-card summary-card-red" style={{
          padding: "12px 16px",
          borderRadius: "10px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          minHeight: "90px",
        }}>
          <div className="card-icon" style={{ color: '#F44336' }}>
            <UserX size={32} />
          </div>
          <div className="card-content">
            <h3 className="card-title">Not Identified</h3>
            <p className="card-value">{liveDashboard.unknownInside || 0}</p>
          </div>
        </div>
      </div>
    </div>
  </>
) : 
  viewMode === 'analytics' && analyticsResponse ? (
        // New analytics summary cards
        <div className="lcm-stat-section">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "16px" }}>
                <div className="summary-card summary-card-green" style={{
                    padding: "12px 16px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    minHeight: "90px",
                }}>
                    <div className="card-icon" style={{ color: '#4CAF50' }}>
                        <TrendingUp size={32} />
                    </div>
                    <div className="card-content">
                        <h3 className="card-title">In</h3>
                        <p className="card-value">{analyticsResponse.todayEntries || 0}</p>
                    </div>
                </div>
                
                <div className="summary-card summary-card-blue" style={{
                    padding: "12px 16px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    minHeight: "90px",
                }}>
                    <div className="card-icon" style={{ color: '#2196F3' }}>
                        <TrendingUp size={32} style={{ transform: 'rotate(180deg)' }} />
                    </div>
                    <div className="card-content">
                        <h3 className="card-title">Out</h3>
                        <p className="card-value">{analyticsResponse.todayExits || 0}</p>
                    </div>
                </div>
                
                <div className="summary-card summary-card-purple" style={{
                    padding: "12px 16px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    minHeight: "90px",
                }}>
                    <div className="card-icon" style={{ color: '#9C27B0' }}>
                        <Users size={32} />
                    </div>
                    <div className="card-content">
                        <h3 className="card-title">Total count</h3>
                        <p className="card-value">{analyticsResponse.insideTotal || 0}</p>
                    </div>
                </div>
                
                <div className="summary-card summary-card-orange" style={{
                    padding: "12px 16px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    minHeight: "90px",
                }}>
                    <div className="card-icon" style={{ color: '#FF9800' }}>
                        <UserCheck size={32} />
                    </div>
                    <div className="card-content">
                        <h3 className="card-title">Identified</h3>
                        <p className="card-value">{analyticsResponse.knownInside || 0}</p>
                    </div>
                </div>
                
                <div className="summary-card summary-card-red" style={{
                    padding: "12px 16px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    minHeight: "90px",
                }}>
                    <div className="card-icon" style={{ color: '#F44336' }}>
                        <UserX size={32} />
                    </div>
                    <div className="card-content">
                        <h3 className="card-title">Not Identified</h3>
                        <p className="card-value">{analyticsResponse.unknownInside || 0}</p>
                    </div>
                </div>
            </div>
        </div>
    ) : null}
                
               
            </div>

            {/* View Mode Rendering */}
            {viewMode === 'single' && (
                <div className="crowd-monitoring-content">
                    {/* Live Camera Feed */}
                    <div className="camera-feed-section">
                        <div className="live-camera-feed">
                           <div className="feed-header">
    <h3>
        {faceStatsFailed ? '🔴 FEED OFFLINE' : (isLive ? '🔴 LIVE FEED' : '⏸ PAUSED')}
        {isRecording && (
            <span className="recording-indicator">
                ⏺ REC {formatDuration(recordingDuration)}
            </span>
        )}
    </h3>
</div>
<div className="video-container">
    {cameraError || faceStatsFailed ? (
        <div className="video-placeholder">
            <Video size={64} style={{ color: '#F44336', marginBottom: '16px' }} />
            <p style={{ color: '#F44336', fontSize: '16px', marginBottom: '8px' }}>
                {faceStatsFailed ? 'Live feed is off' : 'Camera Access Error'}
            </p>
            <p style={{ color: '#666', fontSize: '14px' }}>
                {faceStatsFailed 
                    ? 'The camera server might be offline.' 
                    : cameraError}
            </p>
        </div>
    ) : (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img
                ref={videoRef}
                id="cameraStream"
                src={streamUrl}
                alt="Live Camera"
                crossOrigin="anonymous"
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    backgroundColor: '#000'
                }}
            />
            {!isLive && (
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: '#000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: '24px',
                    zIndex: 10
                }}>
                    PAUSED
                </div>
            )}
            <canvas
                ref={canvasRef}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none'
                }}
            />
        </div>
    )}
</div>
                            <div className="video-actions">
                                 <button 
        onClick={captureSnapshot} 
        className="action-btn"
        disabled={faceStatsFailed}
        style={faceStatsFailed ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
    >
        <Camera size={18} />
        Snapshot
    </button>
    <button 
        onClick={toggleRecording} 
        className={`action-btn ${isRecording ? 'recording' : ''}`}
        disabled={faceStatsFailed}
        style={faceStatsFailed ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
    >
        {isRecording ? (
            <>
                <Pause size={18} />
                Stop Recording
            </>
        ) : (
            <>
                <Video size={18} />
                Start Recording
            </>
        )}
    </button>
    <button 
        className={`control-btn ${isLive ? 'active' : ''}`}
        onClick={() => setIsLive(!isLive)}
        disabled={faceStatsFailed}
        style={faceStatsFailed ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
    >
        {isLive ? (
            <>
                <Pause size={18} />
                <span>Pause</span>
            </>
        ) : (
            <>
                <Play size={18} />
                <span>Resume</span>
            </>
        )}
    </button>

                    {/* <button 
                        className={`control-btn ${alertsEnabled ? 'active' : ''}`}
                        onClick={() => setAlertsEnabled(!alertsEnabled)}
                    >
                        {alertsEnabled ? (
                            <>
                                <Bell size={18} />
                                <span>Alerts On</span>
                            </>
                        ) : (
                            <>
                                <BellOff size={18} />
                                <span>Alerts Off</span>
                            </>
                        )}
                    </button> */}
                            </div>
                        </div>

                        {/* Zone Status Cards */}
                        {showZones && (
                            <div className="zone-status-section">
                                <h4>Zone Monitoring</h4>
                                <div className="zone-cards">
                                    {zones.map(zone => {
                                        const occupancyPercent = (zone.current / zone.capacity) * 100;
                                        let statusColor = '#4CAF50';
                                        let statusText = 'Normal';
                                        
                                        if (occupancyPercent > 80) {
                                            statusColor = '#F44336';
                                            statusText = 'Critical';
                                        } else if (occupancyPercent > 60) {
                                            statusColor = '#FF9800';
                                            statusText = 'Warning';
                                        }

                                        return (
                                            <div key={zone.id} className="zone-card">
                                                <div className="zone-header">
                                                    <MapPin size={16} style={{ color: statusColor }} />
                                                    <span>{zone.name}</span>
                                                </div>
                                                <div className="zone-stats">
                                                    <div className="zone-count">
                                                        {zone.current} / {zone.capacity}
                                                    </div>
                                                    <div className="zone-bar">
                                                        <div 
                                                            className="zone-bar-fill"
                                                            style={{
                                                                width: `${Math.min(100, occupancyPercent)}%`,
                                                                backgroundColor: statusColor
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="zone-status" style={{ color: statusColor }}>
                                                        {statusText}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Alerts Panel */}
                    <div className="alerts-section">
                        <div className="alerts-panel">
                           <div className="alerts-header">
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <h3>Alerts & Notifications</h3>
        <button 
            onClick={markAllNotificationsAsRead}
            className="icon-btn"
            title="Mark all as read"
            style={{
                padding: '6px 12px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '13px',
                backgroundColor: '#2196F3',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#1a7a73'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#2196F3'}
        >
            <Check size={16} />
            Mark all read
        </button>
    </div>
    <div className="alerts-actions">
        <button 
            className="icon-btn" 
            onClick={refreshData}
            title="Refresh"
        >
            <RefreshCw size={18} />
        </button>
    </div>
</div>

                            {/* Alert Filters */}
                            {/* <div className="alert-filters">
                                <div className="search-box">
                                    <Search size={16} />
                                    <input
                                        type="text"
                                        placeholder="Search by name..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <select 
                                    value={alertFilter} 
                                    onChange={(e) => setAlertFilter(e.target.value)}
                                    className="filter-select"
                                >
                                    <option value="all">All Alerts</option>
                                    <option value="known">Matched Only</option>
                                    <option value="unknown">Unmatched Only</option>
                                </select>
                            </div> */}

                            {!alertsEnabled && (
                                <div className="alerts-disabled-message">
                                    <BellOff size={20} />
                                    <p>Alerts are currently disabled</p>
                                </div>
                            )}

                            <div className="alerts-list">
    {filteredAlerts.length === 0 ? (
        <div className="no-alerts">
            <AlertTriangle size={32} style={{ color: '#999', marginBottom: '8px' }} />
            <p>No alerts match your filters</p>
        </div>
    ) : (
        filteredAlerts.map((alert) => (
            <div 
                key={alert.id} 
                className="alert-item"
                style={{ 
                    borderLeftColor: getSeverityColor(alert.severity),
                    cursor: alert.isRead ? 'default' : 'pointer',
                    opacity: alert.isRead ? 0.7 : 1,
                    transition: 'all 0.2s'
                }}
                onClick={() => markNotificationAsRead(alert.id, alert.isRead)}
                onMouseEnter={(e) => {
                    if (!alert.isRead) {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                    }
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '';
                }}
            >
                <div className="alert-time">
                    {formatTime(alert.time)}
                </div>
                <div className="alert-content">
                    <div className="alert-header-row">
                        <span className="alert-icon">
                            {alert.notificationType === 'UNKNOWN_PERSON_ALERT' ? '🔴' : '🟢'}
                        </span>
                        <span className="alert-type">
                            {alert.notificationTitle || formatAlertType(alert.type)}
                        </span>
                    </div>
                    <div className="alert-description">
                        {alert.seqCode && (
                            <div style={{ 
                                fontSize: '12px', 
                                color: '#666', 
                                marginBottom: '4px',
                                fontFamily: 'monospace'
                            }}>
                                📋 {alert.seqCode}
                            </div>
                        )}
                        <p><strong>{alert.notificationMessage || alert.description}</strong></p>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            marginTop: '8px',
                            fontSize: '13px'
                        }}>
                            <span className="alert-camera">📷 {alert.camera}</span>
                            {alert.unKnownCount > 0 && (
                                <span style={{ 
                                    color: '#F44336',
                                    fontWeight: '500'
                                }}>
                                    👤 {alert.unKnownCount} unknown
                                </span>
                            )}
                        </div>
                        {!alert.isRead && (
                            <div style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: '#2196F3',
                                animation: 'pulse 2s infinite'
                            }} 
                            title="Unread notification"
                            />
                        )}
                        {alert.isRead && (
                            <div style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                color: '#4CAF50',
                                fontSize: '12px',
                                fontWeight: '500'
                            }} 
                            title="Read"
                            >
                                ✓
                            </div>
                        )}
                    </div>
                </div>
            </div>
        ))
    )}
</div>
                        </div>
                    </div>
                </div>
            )}

            {viewMode === 'grid' && (
                <div className="grid-view-container">
                    <div className="grid-layout">
                        {cameras.length === 0 ? (
                            <div className="no-cameras-message">
                                <Video size={64} style={{ color: '#999', marginBottom: '16px' }} />
                                <p>No cameras available</p>
                            </div>
                        ) : (
                            cameras.map((camera) => (
                                <div key={camera.cameraId} className="grid-camera-item">
                                    <div className="grid-camera-header">
                                        <span>{camera.cameraName}</span>
                                        <button onClick={() => {
                                            setSelectedCamera(camera.cameraId);
                                            setStreamUrl(camera.streamUrl);
                                            setViewMode('single');
                                        }}>
                                            <Maximize2 size={16} />
                                        </button>
                                    </div>
                                    <div className="grid-camera-feed">
                                        <img
                                            src={camera.streamUrl}
                                            alt={camera.cameraName}
                                            crossOrigin="anonymous"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                backgroundColor: '#000'
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'flex';
                                            }}
                                            onLoad={(e) => {
                                                e.target.style.display = 'block';
                                                e.target.nextSibling.style.display = 'none';
                                            }}
                                        />
                                        <div className="video-placeholder" style={{ display: 'none' }}>
                                            <Video size={48} style={{ color: '#999' }} />
                                            <p>{camera.cameraName}</p>
                                            <span style={{ fontSize: '12px', color: '#666' }}>
                                                Stream unavailable
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}

           {viewMode === 'analytics' && analyticsResponse && (
    <div className="analytics-dashboard">
        <div className="analytics-row">
            {/* Crowd Trends Card */}
            <div className="analytics-card">
                <div className="analytics-card-header">
                    <TrendingUp size={20} />
                    <h4>Crowd Trends</h4>
                </div>
                <div className="analytics-content">
                    <div className="stat-row">
                        <span>Peak Hours:</span>
                        <strong>{formatPeakHour(analyticsResponse.peakHour?.hour)}</strong>
                    </div>
                    <div className="stat-row">
                        <span>Peak Hour Crowd Size:</span>
                        <strong>{analyticsResponse.peakHour?.total || 0}</strong>
                    </div>
                </div>
            </div>

            {/* Traffic Flow Card */}
            <div className="analytics-card">
                <div className="analytics-card-header">
                    <Activity size={20} />
                    <h4>Traffic Flow</h4>
                </div>
                <div className="analytics-content">
                    <div className="flow-chart">
                        <div className="flow-item">
                            <span className="flow-label">Entry</span>
                            <div className="flow-bar entry">
                                <div 
                                    className="flow-bar-fill"
                                    style={{ 
                                        width: `${Math.min(100, ((analyticsResponse.todayEntries || 0) / Math.max(1, (analyticsResponse.todayEntries || 0) + (analyticsResponse.todayExits || 0))) * 100)}%`, 
                                        backgroundColor: '#4CAF50' 
                                    }}
                                />
                            </div>
                            <span className="flow-value">{analyticsResponse.todayEntries || 0}</span>
                        </div>
                        <div className="flow-item">
                            <span className="flow-label">Exit</span>
                            <div className="flow-bar exit">
                                <div 
                                    className="flow-bar-fill"
                                    style={{ 
                                        width: `${Math.min(100, ((analyticsResponse.todayExits || 0) / Math.max(1, (analyticsResponse.todayEntries || 0) + (analyticsResponse.todayExits || 0))) * 100)}%`, 
                                        backgroundColor: '#2196F3' 
                                    }}
                                />
                            </div>
                            <span className="flow-value">{analyticsResponse.todayExits || 0}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Detection Breakdown Card */}
            <div className="analytics-card">
                <div className="analytics-card-header">
                    <PieChart size={20} />
                    <h4>Detection Breakdown</h4>
                </div>
                <div className="analytics-content">
                    <div className="pie-stats">
                        <div className="pie-stat">
                            <div className="pie-color" style={{ backgroundColor: '#4CAF50' }} />
                            <span>Identified</span>
                            <strong>{analyticsResponse.knownInside || 0}</strong>
                        </div>
                        <div className="pie-stat">
                            <div className="pie-color" style={{ backgroundColor: '#F44336' }} />
                            <span>Not Identified</span>
                            <strong>{analyticsResponse.unknownInside || 0}</strong>
                        </div>
                    </div>
                    <div className="percentage-bar">
                        <div 
                            className="percentage-fill known"
                            style={{ 
                                width: `${((analyticsResponse.knownInside || 0) / Math.max(1, (analyticsResponse.knownInside || 0) + (analyticsResponse.unknownInside || 0))) * 100}%`,
                                backgroundColor: '#4CAF50'
                            }}
                        />
                        <div 
                            className="percentage-fill unknown"
                            style={{ 
                                width: `${((analyticsResponse.unknownInside || 0) / Math.max(1, (analyticsResponse.knownInside || 0) + (analyticsResponse.unknownInside || 0))) * 100}%`,
                                backgroundColor: '#F44336'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>

        {/* Detection History Table with Pagination - UPDATED */}
        <div className="analytics-card full-width">
            <div className="analytics-card-header">
                <Eye size={20} />
                <h4>Recent Detection History</h4>
            </div>
            <div className="analytics-content">
                {analyticsResponse.detectionHistory && analyticsResponse.detectionHistory.length > 0 ? (
                    <>
                        <div className="detection-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Event Time</th>
                                        <th>Camera Type</th>
                                        <th>Total Count</th>
                                        <th>Identified</th>
                                        <th>Not Identified</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentDetections.map((detection, index) => (
                                        <tr key={index}>
                                            <td>{formatTime(detection.event_time)}</td>
                                            <td>
                                                <span className={`status-badge ${(detection.camera_type || '').toLowerCase()}`}>
                                                    {detection.camera_type || 'N/A'}
                                                </span>
                                            </td>
                                            <td>
                                                <strong>{detection.total_count || 0}</strong>
                                            </td>
                                            <td style={{ color: '#4CAF50', fontWeight: '500' }}>
                                                {detection.known_count || 0}
                                            </td>
                                            <td style={{ color: '#F44336', fontWeight: '500' }}>
                                                {detection.unknown_count || 0}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        {/* Pagination Controls */}
                        {totalPages >= 1 && (
                            <div className="lcm-pagination">
                                {/* Entry count */}
                                <span className="lcm-pagination-info">
                                    Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, analyticsResponse.detectionHistory.length)} of {analyticsResponse.detectionHistory.length} Entries
                                </span>

                                <div className="lcm-pagination-controls">
                                    {/* Go to page */}
                                    <span className="lcm-pagination-goto-label">Go to Page:</span>
                                    <input
                                        type="number"
                                        min={1}
                                        max={totalPages}
                                        value={currentPage}
                                        onChange={e => {
                                            const v = Number(e.target.value);
                                            if (v >= 1 && v <= totalPages) handlePageChange(v);
                                        }}
                                        className="lcm-pagination-goto"
                                    />

                                    {/* Prev */}
                                    <button
                                        className="lcm-page-btn lcm-page-nav"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >&lt;</button>

                                    {/* Windowed page buttons */}
                                    {(() => {
                                        const pages = [];
                                        const delta = 2;
                                        const left  = Math.max(1, currentPage - delta);
                                        const right = Math.min(totalPages, currentPage + delta);

                                        if (left > 1) {
                                            pages.push(1);
                                            if (left > 2) pages.push('…');
                                        }
                                        for (let i = left; i <= right; i++) pages.push(i);
                                        if (right < totalPages) {
                                            if (right < totalPages - 1) pages.push('…');
                                            pages.push(totalPages);
                                        }

                                        return pages.map((p, i) =>
                                            p === '…' ? (
                                                <span key={`e${i}`} className="lcm-page-ellipsis">…</span>
                                            ) : (
                                                <button
                                                    key={p}
                                                    className={`lcm-page-btn${currentPage === p ? ' lcm-page-active' : ''}`}
                                                    onClick={() => handlePageChange(p)}
                                                >{p}</button>
                                            )
                                        );
                                    })()}

                                    {/* Next */}
                                    <button
                                        className="lcm-page-btn lcm-page-nav"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >&gt;</button>

                                    {/* Page X / Total */}
                                    <span className="lcm-pagination-total">{currentPage}/{totalPages}</span>
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div style={{ 
                        textAlign: 'center', 
                        padding: '40px', 
                        color: '#999' 
                    }}>
                        <Eye size={48} style={{ marginBottom: '16px', opacity: 0.5 }} />
                        <p>No detection history available for the selected date range</p>
                    </div>
                )}
            </div>
        </div>
    </div>
)}
{viewMode === 'recordings' && (
    <div className="recordings-view-container">
        {/* Filters Section */}
        <div className="recordings-filters-section">
            <div className="filters-row">
                <div className="filter-group">
                    <label>From Date:</label>
                    <input
                        type="date"
                        value={recordingFilters.fromDate}
                        onChange={(e) => setRecordingFilters(prev => ({ 
                            ...prev, 
                            fromDate: e.target.value 
                        }))}
                        className="date-input"
                    />
                </div>
                <div className="filter-group">
                    <label>To Date:</label>
                    <input
                        type="date"
                        value={recordingFilters.toDate}
                        onChange={(e) => setRecordingFilters(prev => ({ 
                            ...prev, 
                            toDate: e.target.value 
                        }))}
                        className="date-input"
                    />
                </div>
                <div className="filter-group">
                    <label>Camera:</label>
                    <select 
                        value={recordingFilters.cameraId}
                        onChange={(e) => setRecordingFilters(prev => ({ 
                            ...prev, 
                            cameraId: e.target.value 
                        }))}
                        className="camera-select"
                        disabled={cameras.length === 0}
                    >
                        <option value="ALL">All Cameras</option>
                        {cameras.map((camera) => (
                            <option key={camera.cameraId} value={camera.cameraId}>
                                {camera.cameraName}
                            </option>
                        ))}
                    </select>
                </div>
                <button 
                    onClick={fetchRecordings}
                    className="apply-filter-btn"
                    disabled={isLoadingRecordings}
                >
                    {isLoadingRecordings ? 'Loading...' : 'Apply'}
                </button>
            </div>
        </div>

        {isLoadingRecordings ? (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '400px' 
            }}>
                <LoadingOverlay message="Loading recordings..." />
            </div>
        ) : (
            <div className="recordings-content">
                {/* Recordings List */}
                <div className="recordings-list">
                    <div className="recordings-list-header">
                        <h4>Recordings ({recordings.length})</h4>
                    </div>
                    {recordings.length === 0 ? (
                        <div className="no-recordings">
                            <Video size={48} style={{ color: '#999', marginBottom: '16px' }} />
                            <p>No recordings found</p>
                            <span style={{ fontSize: '14px', color: '#666' }}>
                                Try selecting a different date range or camera
                            </span>
                        </div>
                    ) : (
                        <div className="recordings-grid">
                            {recordings.map((recording) => (
                                <div 
                                    key={recording.recordingId}
                                    className={`recording-card ${selectedRecording?.recordingId === recording.recordingId ? 'active' : ''}`}
                                    onClick={() => setSelectedRecording(recording)}
                                >
                                    <div className="recording-thumbnail">
                                        <Video size={32} />
                                    </div>
                                    <div className="recording-info">
                                        <div className="recording-camera">
                                            <Camera size={14} />
                                            <span>{recording.cameraId}</span>
                                        </div>
                                        <div className="recording-time">
                                            <Clock size={12} />
                                            <span className="time-label">Start:</span>
                                            <span>{formatTime12Hour(recording.startTime)}</span>
                                        </div>
                                        <div className="recording-time">
                                            <Clock size={12} />
                                            <span className="time-label">End:</span>
                                            <span>{formatTime12Hour(recording.endTime)}</span>
                                        </div>
                                        <div className="recording-status">
                                            <span className={`status-badge ${recording.status.toLowerCase()}`}>
                                                {recording.status}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Video Player */}
                <div className="recording-player">
                    {selectedRecording ? (
                        <>
                            <div className="player-header">
                                <div className="player-title">
                                    <Camera size={20} />
                                    <h4>{selectedRecording.cameraId}</h4>
                                </div>
                                {/* <div className="player-actions">
                                    <button 
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = selectedRecording.playlistUrl;
                                            link.download = `recording_${selectedRecording.recordingId}.m3u8`;
                                            link.click();
                                        }}
                                        className="action-btn"
                                        title="Download Playlist"
                                    >
                                        <Download size={18} />
                                        Download
                                    </button>
                                </div> */}
                            </div>
                            <div className="player-wrapper">
                                <video
                                    ref={recordingVideoRef}
                                    controls
                                    style={{ 
                                        width: '100%', 
                                        height: '100%',
                                        backgroundColor: '#000'
                                    }}
                                />
                            </div>
                            <div className="recording-details">
                                {/* <div className="detail-item">
                                    <span>Recording ID:</span>
                                    <strong style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                                        {selectedRecording.recordingId}
                                    </strong>
                                </div> */}
                                <div className="detail-item">
                                    <span>Start Time:</span>
                                    <strong>{formatTime12Hour(selectedRecording.startTime)}</strong>
                                </div>
                                <div className="detail-item">
                                    <span>End Time:</span>
                                    <strong>{formatTime12Hour(selectedRecording.endTime)}</strong>
                                </div>
                                <div className="detail-item">
                                    <span>Status:</span>
                                    <strong>
                                        <span className={`status-badge ${selectedRecording.status.toLowerCase()}`}>
                                            {selectedRecording.status}
                                        </span>
                                    </strong>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="no-video-selected">
                            <Video size={64} style={{ color: '#999', marginBottom: '16px' }} />
                            <p>Select a recording to play</p>
                        </div>
                    )}
                </div>
            </div>
        )}
    </div>
)}
        </div>
    );
};

export default RealTimeCrowdMonitoring;